<template>
  <b-container class="mt-5 text-center">
    <h2>Bienvenido, {{ user?.name }}</h2>
    <b-button variant="danger" @click="logout">Cerrar sesión</b-button>
  </b-container>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
  },
};
</script>
